import { useQuery } from '@tanstack/react-query'
import { PartnerService } from '@duck/api-definitions'
import { apis } from '@/modules/apiClients'
import { useAuth } from '@/hooks/useAuth'

export const cohortBoardQueryKey = (cohortId: string) => ['cohorts', 'board', cohortId] as const

export const fetchCohortBoard = async (cohortId: string): Promise<PartnerService.CohortBoardResponse> => {
  const response = await apis.partnerService.cohortsCohortIdBoardGet(cohortId)
  return response.data
}

export const useCohortBoard = (cohortId: string) => {
  const { isPartner, isAdmin } = useAuth()
  const query = useQuery({
    queryKey: cohortBoardQueryKey(cohortId),
    queryFn: () => fetchCohortBoard(cohortId),
    enabled: (isPartner || isAdmin) && cohortId !== '',
    staleTime: 30 * 60 * 1000,
  })
  return {
    cohort: query.data?.data,
    assignments: query.data?.assignments ?? [],
    assignmentsDetails: query.data?.assignmentsDetails ?? [],
    publicAssignments: query.data?.publicAssignments ?? [],
    taskNames: query.data?.taskNames ?? {},
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  }
}
